import { Popover } from 'antd';
import { Link } from 'react-router-dom';
import logoQuocHung from '@app/assets/images/logo.png';
import RouteAuthentication from '../../../routeAuth';

const ModulePopoverContent = () => {
    const modules = RouteAuthentication.getModule();

    return (
        <div className="module-popover-content">
            {modules.map((item) => (
                <Link
                    key={item.path || item.link}
                    className="module-popover-item"
                    to={item.link || item.path || '/'}
                    style={
                        item.themeColor
                            ? ({ '--module-color': item.themeColor } as React.CSSProperties)
                            : undefined
                    }
                >
                    <span className="module-popover-icon">
                        {item.icon && (
                            <img
                                src={item.icon}
                                alt={
                                    typeof item.name === 'string'
                                        ? item.name
                                        : ''
                                }
                            />
                        )}
                    </span>
                    <span className="module-popover-label text-center">
                        {item.name}
                    </span>
                </Link>
            ))}
        </div>
    );
};

const MenuPopover = () => (
    <div className="navbar-header">
        <Popover
            content={<ModulePopoverContent />}
            trigger="hover"
            placement="bottom"
            arrow
            classNames={{ root: 'module-popover-overlay' }}
        >
            <span className="navbar-brand" id="link-module-sc">
                <img src={logoQuocHung} alt="Logo" />
            </span>
        </Popover>
    </div>
);

export default MenuPopover;
